import {
  Key,
  ClipboardCheck,
  Sparkles,
  Wrench,
  Shirt,
  HeartHandshake,
  Camera,
  BarChart3,
  ThumbsUp,
  Award,
  FileText,
} from "lucide-react";
import {
  IMG_HERO_1, IMG_HERO_2, IMG_HERO_3,
  IMG_FALLBACK_1, IMG_FALLBACK_2, IMG_FALLBACK_3,
  IMG_COZY_LIVING, IMG_STONE_FIREPLACE, IMG_FRENCH_VILLAGE,
  IMG_NARROW_STREET, IMG_SERVICE_REMISE_CLES, IMG_SERVICE_ETATS_LIEUX,
  IMG_SERVICE_MENAGE, IMG_SERVICE_LINGE, IMG_SERVICE_MAINTENANCE,
  IMG_SERVICE_CONCIERGERIE, IMG_SERVICE_PHOTOS, IMG_SERVICE_TARIFICATION,
} from "./images";

export const HERO_SLIDES = [
  { image: IMG_HERO_1, subtitle: "Limoges & alentours" },
  { image: IMG_HERO_2, subtitle: "Des intérieurs modernes" },
  { image: IMG_HERO_3, subtitle: "Un confort exceptionnel" },
];

export const FALLBACK_IMAGES = [IMG_FALLBACK_1, IMG_FALLBACK_2, IMG_FALLBACK_3];

export const BANNER_IMAGES = {
  cozyLiving:     IMG_COZY_LIVING,
  stoneFireplace: IMG_STONE_FIREPLACE,
  frenchVillage:  IMG_FRENCH_VILLAGE,
  luxuryBedroom:  IMG_FALLBACK_3,
  narrowStreet:   IMG_NARROW_STREET,
};

export const services = [
  {
    icon: Key,
    title: "Remise des clés",
    description: "Un accueil chaleureux pour chaque voyageur, à toute heure. Présentation personnalisée du logement, guide de bienvenue et recommandations locales.",
    highlights: ["Accueil en personne 7j/7", "Livret d'accueil personnalisé", "Recommandations restaurants & activités"],
    stat: { value: "7j/7", label: "Disponibilité" },
    image: IMG_SERVICE_REMISE_CLES,
  },
  {
    icon: ClipboardCheck,
    title: "États des lieux",
    description: "Protection complète de votre bien grâce à des états des lieux photographiques réalisés à chaque entrée et sortie de voyageur.",
    highlights: ["Reportage photo avant/après", "Inventaire détaillé du mobilier", "Signalement immédiat de tout dommage"],
    stat: { value: "100%", label: "Transparence" },
    image: IMG_SERVICE_ETATS_LIEUX,
  },
  {
    icon: Sparkles,
    title: "Ménage inter-séjour",
    description: "Nettoyage professionnel après chaque départ selon un protocole hôtelier strict. Votre logement est impeccable pour chaque arrivée.",
    highlights: ["Protocole de nettoyage en 45 points", "Produits éco-responsables", "Contrôle qualité systématique"],
    stat: { value: "98%", label: "Satisfaction" },
    image: IMG_SERVICE_MENAGE,
  },
  {
    icon: Shirt,
    title: "Gestion du linge",
    description: "Fourniture, lavage et remplacement du linge de maison à chaque rotation. Draps, serviettes et torchons de qualité hôtelière.",
    highlights: ["Linge blanc qualité premium", "Lavage professionnel à 60°C", "Stock de remplacement permanent"],
    stat: { value: "5 étoiles", label: "Qualité" },
    image: IMG_SERVICE_LINGE,
  },
  {
    icon: Wrench,
    title: "Maintenance & Réparations",
    description: "Réseau d'artisans locaux de confiance pour intervenir rapidement. De la petite réparation à la rénovation, votre bien est toujours en parfait état.",
    highlights: ["Intervention sous 24h en urgence", "Artisans certifiés et assurés", "Devis validé avant intervention"],
    stat: { value: "<24h", label: "Réactivité" },
    image: IMG_SERVICE_MAINTENANCE,
  },
  {
    icon: HeartHandshake,
    title: "Conciergerie 24/7",
    description: "Assistance continue pour vos voyageurs : questions, demandes spéciales, gestion des imprévus. Un interlocuteur dédié à toute heure.",
    highlights: ["Ligne d'urgence 24h/24", "Gestion des réclamations", "Coordination check-in tardifs"],
    stat: { value: "24/7", label: "Assistance" },
    image: IMG_SERVICE_CONCIERGERIE,
  },
  {
    icon: Camera,
    title: "Photos & Annonces pro",
    description: "Shooting photo professionnel de votre logement et création d'annonces optimisées sur toutes les plateformes : Airbnb, Booking, Abritel.",
    highlights: ["Photographe professionnel", "Rédaction SEO des annonces", "Diffusion multi-plateformes"],
    stat: { value: "+40%", label: "Visibilité" },
    image: IMG_SERVICE_PHOTOS,
  },
  {
    icon: BarChart3,
    title: "Tarification dynamique",
    description: "Optimisation quotidienne de vos tarifs en fonction de la demande, la saisonnalité et les événements locaux pour maximiser vos revenus.",
    highlights: ["Algorithme de pricing intelligent", "Analyse concurrentielle en temps réel", "Rapport mensuel détaillé"],
    stat: { value: "+25%", label: "Revenus" },
    image: IMG_SERVICE_TARIFICATION,
  },
];

export const whyUs = [
  {
    icon: ThumbsUp,
    title: "Meilleurs prix garantis",
    description: "Des tarifs optimisés grâce au yield management pour maximiser vos revenus tout en restant compétitifs sur le marché local.",
  },
  {
    icon: Award,
    title: "Une expérience distinctive",
    description: "Chaque logement Happy House est conçu pour offrir plus qu'un séjour : un véritable moment d'exception, validé par nos voyageurs.",
  },
  {
    icon: FileText,
    title: "Transparence radicale",
    description: "Des comptes rendus clairs et sans astérisques cachées. Rapports mensuels détaillés : revenus, occupation, prestations.",
  },
];
